module.exports = __webpack_public_path__ + "04d4e8666add85034752435efb56463a.png";